var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [!_vm.options.hideLabel ? _c('div', {
    class: _vm.$style.labelContainer
  }, [_c('div', [_c('p', {
    staticClass: "p1",
    class: _vm.$style.label
  }, [_vm._v(" " + _vm._s(_vm.label) + ": "), _vm.isRequired && _vm.editMode && !_vm.options.hideAsterisk ? _c('span', {
    class: _vm.$style.requiredAsterisk,
    attrs: {
      "data-required-asterisk": ""
    }
  }, [_vm._v(" * ")]) : _vm._e()])]), _vm.copyable && _vm.value ? _c('CopyToClipboardButton', {
    class: _vm.$style.copyToClipboardButton,
    attrs: {
      "theme": "square",
      "text-to-copy": _vm.value
    }
  }) : _vm._e(), _c('div', [_vm.tooltipText ? _c('Tooltip', {
    attrs: {
      "target": "".concat(_vm.label).concat(_vm.formItemId),
      "placement": "top",
      "theme": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.tooltipText) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm.subLabel && _vm.editMode ? _c('p', {
    class: _vm.$style.formItemSubLabel
  }, [_vm._v(_vm._s(_vm.subLabel))]) : _vm._e(), !_vm.editMode ? [_c('div', {
    class: _vm.$style.valueContainer
  }, [_vm.showInListFormat && _vm.value instanceof Array && !_vm.value.length ? _c('h4', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s('N/A'))]) : _vm.showInListFormat ? _c('ul', {
    class: _vm.$style.valuesList
  }, [_vm.value instanceof Array ? _vm._l(_vm.value, function (item) {
    return _c('li', {
      key: item
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }) : _vm._l(_vm.valueArray, function (item) {
    return _c('li', {
      key: item
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  })], 2) : _vm.value ? _c('h4', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s(_vm.formattedValue || 'N/A'))]) : _c('h4', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s('N/A'))]), _vm._t("afterValue")], 2)] : _vm._e(), _vm.editMode ? [_c('ValidationProvider', {
    attrs: {
      "debounce": 300,
      "name": _vm.label,
      "rules": _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors,
          changed = _ref.changed;
        return [_vm.multiSelect ? _c('BaseMultiSelect', {
          attrs: {
            "options": _vm.editSelectValues,
            "placeholder": _vm.placeholder
          },
          on: {
            "input": _vm.onInput
          },
          model: {
            value: _vm.modelValue,
            callback: function callback($$v) {
              _vm.modelValue = $$v;
            },
            expression: "modelValue"
          }
        }) : _vm.editSelectValues ? _c('BaseSelect', {
          attrs: {
            "options": _vm.editSelectValues,
            "option-text": "label",
            "option-value": "value",
            "disabled": _vm.disabled,
            "changed": changed,
            "empty-text": _vm.placeholder
          },
          on: {
            "change": _vm.onInput
          },
          model: {
            value: _vm.modelValue,
            callback: function callback($$v) {
              _vm.modelValue = $$v;
            },
            expression: "modelValue"
          }
        }) : _vm._e(), errors[0] && (_vm.multiSelect || _vm.editSelectValues) ? _c('p', {
          staticClass: "tag-text",
          class: _vm.$style.errorMessage
        }, [_vm._v(" " + _vm._s(errors[0]) + " ")]) : _vm._e(), !_vm.multiSelect && !_vm.editSelectValues ? [_c('BaseInputText', {
          attrs: {
            "disabled": _vm.disabled,
            "mask": _vm.mask,
            "name": _vm.name || _vm.label,
            "error": errors[0],
            "placeholder": _vm.placeholder,
            "textarea": _vm.textarea,
            "changed": changed
          },
          on: {
            "input": _vm.onInput
          },
          model: {
            value: _vm.modelValue,
            callback: function callback($$v) {
              _vm.modelValue = $$v;
            },
            expression: "modelValue"
          }
        })] : _vm._e(), _vm.characterInfo ? _c('p', {
          staticClass: "tag-text",
          class: [_vm.$style.charCounter, _vm.characterInfo.isOverLimit ? _vm.$style.errorMessage : '']
        }, [_vm._v(" " + _vm._s(_vm.characterInfo.currentCharCount) + " of " + _vm._s(_vm.characterInfo.charLimit) + " characters ")]) : _vm._e()];
      }
    }], null, false, 3127839513)
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }